import  { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import {
  actionOptions,
  createTodoList,
  getIdByTodoList,
  statusOptions,
  toDoData,
  toDoStateMange,
  updateTodoList,
} from "../todoData";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialButton from "../../../../components/MaterialButton";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoading } from "../../../../context/LodingContext";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import Swal from "sweetalert2";

const TodoForm = () => {
  // input state mange this state
  const [todo, dispatch] = useReducer(toDoStateMange, toDoData);
  const [inputDisble, setInputDisble] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();

  const formType = location?.state?.type;
  const rowId = location?.state?.rowId;

  useEffect(() => {
    dispatch({
      value: { value: "To Do", label: "To Do" },
      name: "status",
    });
  }, []);

  // change formType Add or edit or View usi ng input disble or enable
  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  useEffect(() => {
    if (rowId) {
      fetchRowData(rowId);
    }
  }, [rowId]);

  // form submit after call this function add or update change condition base
  const handleSubmit = async () => {
    setCirleLoading(true);

    const value = {
      heading: todo?.heading,
      action: todo?.action?.label,
      content: todo?.content,
      status: todo?.status?.label,
    };

    if (formType == "add") {
      await onSumbit(value);
    } else if (formType == "edit") {
      await onUpdate(value);
    }
    setCirleLoading(false);
  };
  // add function
  const onSumbit = async (value) => {
    try {
      const res = await request(BASEURL, createTodoList, {
        input: {
          userId: userId,
          ...value,
        },
      });
      const status = res?.createTodoList?.success;
      const message = res?.createTodoList?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/todo");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {}
  };
  // edit function
  const onUpdate = async (value) => {
    try {
      const res = await request(BASEURL, updateTodoList, {
        input: {
          id: rowId,
          ...value,
        },
      });
      const status = res?.updateTodoList?.success;
      const message = res?.updateTodoList?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/todo");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {}
  };
  // fetchRowdata
  const fetchRowData = async (id) => {
    setCirleLoading(true);
    try {
      const response = await request(BASEURL, getIdByTodoList, {
        id: id,
      });
      const value = response?.getIdByTodoList;
      dispatch({ value: value?.heading, name: "heading" });
      dispatch({
        value: value?.content,
        name: "content",
      });
      dispatch({
        value: { value: value?.action, label: value?.action },
        name: "action",
      });
      dispatch({
        value: { value: value?.status, label: value?.status },
        name: "status",
      });
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add"
                    : formType == "edit"
                    ? "Edit"
                    : "View"}{" "}
                  To Do Details
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Heading <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todo?.heading}
                  name="heading"
                  placeholder="Enter Heading"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "heading" })
                  }
                  error={todo.headingStatus === "error" ? true : false}
                  success={todo.headingStatus === "success" ? true : false}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Action <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="action"
                  value={todo?.action}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={actionOptions?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e) => dispatch({ value: e, name: "action" })}
                  error={todo.actionStatus === "error" ? true : false}
                  success={todo.actionStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Content <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={4}
                  value={todo?.content}
                  name="content"
                  placeholder="Enter Content"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "content" })
                  }
                  error={todo.contentStatus === "error" ? true : false}
                  success={todo.contentStatus === "success" ? true : false}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Status <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="status"
                  value={todo?.status}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={statusOptions?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e) => dispatch({ value: e, name: "status" })}
                  error={todo.statusStatus === "error" ? true : false}
                  success={todo.statusStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/todo")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleSubmit}
              >
                {formType == "add" ? "Submit" : "update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default TodoForm;
